import NormalizedResource from '@/resources/NormalizedResource';
import userSchema from '@/resources/schemas/userSchema';

class UserResource extends NormalizedResource {
  constructor(response) {
    super(response);
    return super.transform(userSchema);
  }
}

export default UserResource;
